// Data for João Xavier Portfolio (replaces previous mock.js)

export const data = {
  musician: {
    name: "João Xavier",
    title: " Classical Pianist",
    email: "joaommxavier@gmail.com",
    youtube: "https://www.youtube.com/@JMMPXavier"
  },

  biography: {
    text: [
      "One of the most promising Portuguese pianists of his generation, João Xavier has captivated audiences across Portugal, Spain, Belgium, Italy and Russia. He has appeared in renowned venues such as Sala Suggia at Casa da Música (Porto), Gulbenkian Foundation Hall (Lisbon), Teatros del Canal (Madrid), the Great Hall of the Brussels Royal Conservatory, Centro Botín (Santander), and the Small, Rachmaninov and Great Halls of the Moscow State Tchaikovsky Conservatory.",
      "A prizewinner of numerous competitions, João has received distinctions such as 1st Prize at the Estoril Festival Competition (2021), 1st Prize at Prémio Jovens Músicos (2011), and 1st Prize at the Póvoa de Varzim, Florinda Santos and Santa Cecília Piano Competitions. In 2014, he was awarded 3rd Prize at the Jaén International Piano Competition.",
      "Born in Lousada, Portugal, João Xavier began his musical studies at the Vale do Sousa Conservatory, graduating in 2011 under Professor Luísa Ferreira. He later studied with Pedro Burmester at ESMAE (Porto), and also worked with Tania Achot-Haroutounian and Eliso Virsaladze at the Scuola di Musica di Fiesole (Florence). In 2020, he graduated with distinction from the Moscow State Tchaikovsky Conservatory under Eliso Virsaladze.",
      "He has performed in festivals such as Festival Internacional de Música da Póvoa de Varzim, Dias da Música (Centro Cultural de Belém), Cistermúsica (Alcobaça), and Midis-Minimes (Brussels).",
      "He has collaborated with conductors including Pedro Neves, Günther Neuhold, Nikolay Lalov, Anatoly Levin, Martin André, Stefan Blunier and Vasily Sinaisky.",
      "He completed his master's degree at the Koninklijk Conservatorium Brussel, studying with Aleksandar Madžar."
    ],
    image: "https://images.unsplash.com/photo-1520523839897-bd0b52f945a0?w=800&q=80"
  },

  videos: [
    { id: "qlZ7qBZALHE", title: "João Xavier Piano Performance I" },
    { id: "CHoaAWOgXuc", title: "João Xavier Piano Performance II" }
  ],

  gallery: [
    { id: 1, url: "/images/Gallery/Gallery_1.webP", alt: "João Xavier performing" },
    { id: 2, url: "/images/Gallery/Gallery_2.webP", alt: "Concert performance at prestigious venue" },
    { id: 3, url: "/images/Gallery/Gallery_3.webP", alt: "Piano recital moment" },
    { id: 4, url: "/images/Gallery/Gallery_4.webP", alt: "Classical performance" },
    { id: 5, url: "/images/Gallery/Gallery_5.webP", alt: "João Xavier at the piano" },
    { id: 6, url: "/images/Gallery/Gallery_6.webP", alt: "Concert hall performance" },
    { id: 7, url: "/images/Gallery/Gallery_7.webP", alt: "Musical expression during performance" },
    { id: 8, url: "/images/Gallery/Gallery_8.webP", alt: "Professional piano performance" },
    { id: 9, url: "/images/Gallery/Gallery_9.webP", alt: "João Xavier in concert" },
    { id: 10, url: "/images/Gallery/Gallery_10.webP", alt: "Classical piano repertoire performance" },
    { id: 11, url: "/images/Gallery/Gallery_11.webP", alt: "Artistic moment during recital" },
    { id: 12, url: "/images/Gallery/Gallery_12.webP", alt: "Piano performance showcase" },
    { id: 13, url: "/images/Gallery/Gallery_13.webP", alt: "João Xavier performing classical music" },
    { id: 14, url: "/images/Gallery/Gallery_14.webP", alt: "Concert performance moment" },
    { id: 15, url: "/images/Gallery/Gallery_15.webP", alt: "Professional pianist at work" },
    { id: 16, url: "/images/Gallery/Gallery_16.webP", alt: "João Xavier piano recital" }
  ],

  repertoire: [
    {
      composer: "W. A. Mozart",
      pieces: [
        'Piano Concerto No. 9 in E-flat major, K. 271 ("Jeunehomme")',
        "Piano Concerto No. 12 in A major, K. 414",
        "Piano Concerto No. 17 in G major, K. 453",
        "Piano Concerto No. 18 in B-flat major, K. 456",
        "Piano Concerto No. 23 in A major, K. 488",
        "Piano Concerto No. 24 in C minor, K. 491",
        "Piano Concerto No. 25 in C major, K. 503"
      ]
    },
    {
      composer: "L. van Beethoven",
      pieces: [
        "Piano Concerto No. 1 in C major, Op. 15",
        "Piano Concerto No. 2 in B-flat major, Op. 19",
        "Piano Concerto No. 3 in C minor, Op. 37",
        "Piano Concerto No. 4 in G major, Op. 58",
        "Piano Concerto No. 5 in E-flat major, Op. 73"
      ]
    },
    {
      composer: "F. Chopin",
      pieces: [
        "Piano Concerto No. 1 in E minor, Op. 11",
        "Piano Concerto No. 2 in F minor, Op. 21"
      ]
    },
    {
      composer: "R. Schumann",
      pieces: [
        "Piano Concerto in A minor, Op. 54",
        "Introduction and Allegro appassionato in G major, Op. 92"
      ]
    },
    {
      composer: "E. Grieg",
      pieces: [
        "Piano Concerto in A minor, Op. 16"
      ]
    },
    {
      composer: "F. Liszt",
      pieces: [
        "Piano Concerto No. 1 in E-flat major",
        "Piano Concerto No. 2 in A major"
      ]
    },
    {
      composer: "J. Brahms",
      pieces: [
        "Piano Concerto No. 2 in B-flat major, Op. 83"
      ]
    },
    {
      composer: "P. I. Tchaikovsky",
      pieces: [
        "Piano Concerto No. 1 in B-flat minor, Op. 23"
      ]
    },
    {
      composer: "S. Rachmaninov",
      pieces: [
        "Piano Concerto No. 1 in F-sharp minor, Op. 1",
        "Piano Concerto No. 2 in C minor, Op. 18"
      ]
    },
    {
      composer: "S. Prokofiev",
      pieces: [
        "Piano Concerto No. 3 in C major, Op. 26",
        "Piano Concerto No. 4 in B-flat major (for left hand), Op. 53"
      ]
    }
  ]
};
